<template>
  <ScrollKeyFrame id="Font2021" class="font-project" :nav-list="sectionList">
    <section class="section-1 main-section">
      <div class="scroll-mark"></div>
      <div class="contents-wrapper">
        <div class="type-main-title h1">2022</div>
        <div class="type-main-description">
          <span>가비아 마음결체 <span class="x-mark hidden collaboration small"></span> 가비아 청연체</span>
        </div>
      </div>
      <video autoplay muted loop playsinline poster="https://static.gabia.com/fonts/project/video/sub_02_poster.png">
        <source src="https://static.gabia.com/fonts/project/video/sub_2.mp4" />
      </video>
    </section>
    <section class="section-2" id="font-info" @mouseenter="autoPlay(true)" @mouseleave="autoPlay(false)">
      <div class="section-contents-wrapper">
        <div class="section-title align-left" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="120">
          <span class="title">제작 의도</span>
        </div>
        <div class="section-contents-project-info"  data-aos="fade-up" data-aos-duration="1000" data-aos-offset="120">
          <div class="project-info-type">
            <div class="type-font-btn" :class="{active_blue: setProjectInfo.name === '마음결체'}" @click="getProjectInfo(0)">가비아 마음결체</div>
            <div class="type-font-btn" :class="{active_green: setProjectInfo.name === '청연체'}" @click="getProjectInfo(1)">가비아 청연체</div>
          </div>
          <h4 class="project-info-title">{{setProjectInfo.title}}</h4>
          <div class="project-info-description font-24">{{setProjectInfo.description}}</div>
          <div class="project-info-slide-wrapper line-card-wrapper">
            <div class="slide-nav-control" :class="setProjectInfo.name === '마음결체' ? 'blue' : 'green'">
              <span class="prev" @click="movePrev">
                <svg width="50" height="50" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <polygon points="25, 18 16, 32 34, 32" class="arrow arrow-left" transform="rotate(-90, 25, 25)"></polygon>
                </svg>
              </span>
              <div class="nav-text"><span class="current">{{activeId + 1}}</span> / {{setProjectInfo.infoList.length}}</div>
              <span class="next" @click="moveNext">
                <svg width="50" height="50" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <polygon points="25, 18 16, 32 34, 32" class="arrow arrow-left" transform="rotate(90, 25, 25)"></polygon>
                </svg>
              </span>
            </div>
            <div class="slide-wrapper">
              <div class="project-info-item" v-for="(item, index) in setProjectInfo.infoList" :key="index"
                   :class="[{current:index === activeId}, {prev:index === previewIndex}, {next:index === nextIndex}]"
              >
                <div class="project-image">
                  <img :src="`https://static.gabia.com/fonts/project/image/${item.image}`" alt="">
                </div>
                <div class="project-text">
                  {{item.text}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-2" id="font-1">
      <div class="section-contents-wrapper">
        <div class="section-title align-left">
          <span class="title underline">가비아 마음결체</span>
          <span class="download-link">
            <a href="https://static.gabia.com/fonts/project/fonts/Download-font/GabiaMaeumgyeol.zip">다운받기 <i class="far fa-arrow-to-bottom"></i></a>
          </span>
        </div>
        <div class="section-description description align-left">
          <p>가비아 마음결체는 사람 사이의 마음을 부드러운 획으로 표현한 가로쓰기 글꼴입니다.<br>
          장식성과 가독성을 모두 만족시켜, 제목과 본문에 두루 사용할 수 있습니다.<br>
            소설이나 시, 영화 포스터와 같이 감성을 자극하는 매체에 어울리는 글꼴입니다</p>
        </div>
        <FontCharacter base-color="#44B4E6" :character-list="maeumgyeolData.list" :character-info="maeumgyeolData.info">
          <img src="https://static.gabia.com/fonts/project/image/font_characters/maeumgyeol.png">
        </FontCharacter>
      </div>
    </section>
    <section class="section-2" id="font-2">
      <div class="section-contents-wrapper">
        <div class="section-title align-left">
          <span class="title underline">가비아 청연체</span>
          <span class="download-link">
            <a href="https://static.gabia.com/fonts/project/fonts/Download-font/GabiaCheongyeon.zip">다운받기 <i class="far fa-arrow-to-bottom"></i></a>
          </span>
        </div>
        <div class="section-description description align-left">
          <p>가비아 청연체는 붓으로 써 내려간 손글씨를 현대적으로 재해석한 세로쓰기 글꼴입니다.<br>
          시와 같은 느린 호흡의 글에 어울리는 글꼴입니다. 본문용 글꼴이지만, 제목으로도 쓸 수 있습니다.</p>
        </div>
        <FontCharacter base-color="#72CE16" :character-list="cheongyeonData.list" :character-info="cheongyeonData.info">
          <img src="https://static.gabia.com/fonts/project/image/font_characters/cheongyeon.svg">
        </FontCharacter>
        <div class="sub-description">*가비아 청연체의 숫자 및 기호 활자 개수는 세로쓰기용 문장부호를 포함하고 있습니다.</div>
      </div>
    </section>
    <section class="section-6 section-sample-editor" id="font-sample">
      <div class="section-contents-wrapper">
        <div class="section-title title  align-left">
          <span class="title">써보기</span>
        </div>
        <div class="section-title description"></div>
        <div class="section-contents-editor line-card-wrapper" ref="editor" :class="[theme]">
          <div class="content-editor-wrapper">
            <div class="sample-text-editor" ref="note"
                  spellcheck="false"
                 :contenteditable="contenteditable" :class="[selectedFont]"
                 :placeholder="`가비아 ${selectedFontText}를 사용해 보세요.`"
                 :style="{ fontSize: `${editorValue.fontSize}px`}"
            >
            </div>
          </div>
          <div class="text-editor-control">
            <div class="control-font-family">
              <ButtonControl :button-list="fontList" :active-color="`green`" @select="setFontFamily" />
            </div>
            <div class="control-font-size">
              <SliderControl :min-value="30" :max-value="100" v-model="editorValue.fontSize" @update="setFontSize"/>
            </div>
            <div class="control-theme">
              <ButtonControl :button-list="themeList" :active-color="`purple`" @select="setTheme" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer />
</ScrollKeyFrame>
</template>

<script>
import ScrollKeyFrame from '@/Modules/ScrollKeyFrame/scrollKeyFrame.vue';
import FontCharacter from '@/components/FontCharacter.vue';
import Footer from '@/components/Footer.vue';
import SliderControl from '@/Modules/sliderControl/sliderControl.vue';
import ButtonControl from '@/Modules/sliderControl/buttonControl.vue';

export default {
  name: 'Font2021',
  components: {
    ScrollKeyFrame, FontCharacter, Footer, SliderControl, ButtonControl,
  },
  data() {
    return {
      theme: 'light',
      scrollTop: 0,
      sectionList: [
        { title: '제작 의도', target: '#font-info' },
        { title: '가비아 마음결체', target: '#font-1' },
        { title: '가비아 청연체', target: '#font-2' },
        { title: '써보기', target: '#font-sample' },
      ],
      autoState: null,
      selectedId: 0,
      activeId: 0,
      projectInfo: [
        {
          id: 0,
          name: '마음결체',
          title: '박주원 디자이너',
          description: '마음의 바탕이라는 뜻의 ‘가비아 마음결체’는 사람 사이에 오가는 마음을 시각적으로 표현한 글꼴입니다. 글이 주는 안정감과 말이 전하는 감수성을 글꼴에 반영했습니다. 기존의 필기 방식과는 다르게 획의 운동감을 강조해 자유로운 인상을 주었습니다. 또한 자음과 모음 사이의 여백을 최소화하여, 작은 크기에서도 쉽게 읽힐 수 있도록 만들었습니다.',
          infoList: [
            {
              text: '시각 흐름선을 위로 두어 글줄이 자연스럽고 편안합니다.',
              image: 'font_project_process/maeumgyeol/carosel-img-1.png',
            },
            {
              text: '곡선을 살린 획의 조형을 활용해 섬세한 리듬감을 느낄 수 있도록 제작했습니다. 특히 닿자 ‘ㅍ, ㅂ, ㅁ’의 새로운 획순과 ‘ㅎ’의 꼭지, 닿자 ‘ㄹ, ㅇ, ㅆ, ㄲ, ㄸ’과 홀자 ‘ㅢ, ㅐ’의 유려하게 이어지는 형태가 특징입니다.',
              image: 'font_project_process/maeumgyeol/carosel-img-2.png',
            },
            {
              text: '가파른 꺾임의 부리 형태를 유지해 개성과 자신감이 느껴집니다.',
              image: 'font_project_process/maeumgyeol/carosel-img-3.png',
            },
            {
              text: '곡선 획이 차지하는 영역에 맞춰 줄기 형태와 사이 공간을 분배했습니다. 특히 겹기둥 사이 공간을 넓히고 ‘ㅑ, ㅕ, ㅒ, ㅖ, ㅛ’에서 발생하는 뭉침 현상을 해결하고자 끊어쓰되 이어진 획의 흔적을 남긴 형태가 특징입니다.',
              image: 'font_project_process/maeumgyeol/carosel-img-4.png',
            },
            {
              text: '한글과 조화를 고려하여 유려한 형태의 로마자와 숫자들 만들었습니다. ‘ㅍ’과 ‘k’에서 볼 수 있듯이 각 언어의 필기 방식을 따르되, 글자의 개성을 유지했습니다.',
              image: 'font_project_process/maeumgyeol/carosel-img-5.png',
            },
          ],
        },
        {
          id: 1,
          name: '청연체',
          title: '구혜민 디자이너',
          description: '맑은 인연이라는 뜻의 ‘가비아 청연체’는 과거의 세로쓰기 반흘림 기법을 현대적으로 재해석한 글꼴입니다. 윤동주 시인의 ‘별 헤는 밤’에서 영감을 얻었습니다. 붓글씨의 유려한 획과 곧게 뻗은 세로줄기를 구현해 시가 가진 서정적인 정서와 단단한 의지를 글꼴에 담아냈습니다.',
          infoList: [
            {
              text: '세로쓰기 글줄에 맞추어 시각 흐름선이 글줄의 오른쪽에 형성되어있습니다. 특히 ‘ㅏ, ㅑ, ㅓ, ㅕ, ㅣ’의 세로 기둥이 일렬로 이어지며 흐름선을 형성합니다.',
              image: 'font_project_process/cheongyeon/carosel-img-1.png',
            },
            {
              text: '손글씨의 흔적이 반영되어 있어 굵기 대비가 확연하고 공간 구조에 따라 낱자의 형태의 변화가 큰 편입니다. 특히 받침 ‘ㄴ, ㄹ, ㅁ’ 등에서 특징적인 형태를 볼 수 있습니다.',
              image: 'font_project_process/cheongyeon/carosel-img-2.png',
            },
            {
              text: '고리점(。)과 모점(、), 낫표(「」), 겹낫표(『 』) 등 한글 세로쓰기 조판에서 활용할 수 있는 문장부호들을 포함하고 있습니다.',
              image: 'font_project_process/cheongyeon/carosel-img-3.png',
            },
            {
              text: '한글 세로쓰기와 조화를 고려하여 로마자의 위치, 크기, 기울기를 조정했습니다.',
              image: 'font_project_process/cheongyeon/carosel-img-4.png',
            },
            {
              text: '바로 선 형태의 고정폭 숫자, 90도 돌아간 형태의 가변폭 숫자, 두 글자씩 붙어있는 숫자까지 총 세 종류의 숫자 세트를 포함하고 있습니다.',
              image: 'font_project_process/cheongyeon/carosel-img-5.png',
            },
          ],
        },
      ],
      maeumgyeolData: {
        info: {
          korean: { text: '2,650자', title: '한글자소' },
          english: { text: '127자', title: '영문자소' },
          number_spacial: { text: '1,047자', title: '숫자 및 기호 활자' },
          otf_size: { text: '669KB', title: 'OTF 용량' },
        },
        list: [
          { id: 0, contents: '부드러운 획의 인상', pos: { top: '52%', left: '11%' } },
          { id: 1, contents: '가파른 꺾임의 부리 형태', pos: { top: '40%', left: '45.5%' } },
          { id: 2, contents: '곡선 획에 맞춰 줄기 형태와 사이 공간을 분배', pos: { top: '49%', left: '66.5%' } },
          { id: 3, contents: '섬세한 리듬감으로 곡선을 살린 획', pos: { top: '44%', left: '88.5%' } },
          { id: 4, contents: '가로쓰기 본문용 글꼴', pos: { top: '10%', left: '92%' } },
        ],
      },
      cheongyeonData: {
        info: {
          korean: { text: '3,251자', title: '한글자소' },
          english: { text: '161자', title: '영문자소' },
          number_spacial: { text: '1,188자', title: '숫자 및 기호 활자' },
          otf_size: { text: '740KB', title: 'OTF 용량' },
        },
        list: [
          { id: 0, contents: '확연한 굵기 대비', pos: { top: '37%', left: '30.5%' } },
          { id: 1, contents: '공간 구조에 따라 변화가 큰 낱자의 형태', pos: { top: '79%', left: '33%' } },
          { id: 2, contents: '세로쓰기용 문장부호', pos: { top: '13%', left: '56.8%' } },
          { id: 3, contents: '선택 가능한 숫자 형태', pos: { top: '26%', left: '77%' } },
          { id: 4, contents: '세로쓰기 본문용 글꼴', pos: { top: '49%', left: '84%' } },
        ],
      },
      selectPoint: -1,
      selectedFont: 'maeumgyeol',
      selectedFontText: '마음결체',
      editorValue: {
        fontSize: 100,
      },
      fontList: [
        { title: '마음결체', name: 'maeumgyeol', addText: true },
        { title: '청연체', name: 'cheongyeon', addText: true },
      ],
      themeList: [
        { title: '밝음', name: 'light' },
        { title: '어두움', name: 'dark' },
      ],
      contenteditable: true,
    };
  },
  computed: {
    setProjectInfo() {
      return this.projectInfo[this.selectedId];
    },
    previewIndex() {
      const pIndex = this.activeId - 1;
      return pIndex < 0 ? this.setProjectInfo.infoList.length - 1 : pIndex;
    },
    nextIndex() {
      const nIndex = this.activeId + 1;
      return nIndex >= this.setProjectInfo.infoList.length ? 0 : nIndex;
    },
  },
  methods: {
    getProjectInfo(type) {
      this.activeId = 0;
      this.selectedId = type;
    },
    movePrev() {
      this.autoPlay(false);
      this.activeId = this.activeId === 0 ? this.setProjectInfo.infoList.length - 1 : this.activeId - 1;
    },
    moveNext() {
      this.autoPlay(false);
      this.activeId = this.activeId === this.setProjectInfo.infoList.length - 1 ? 0 : this.activeId + 1;
    },
    autoPlay(value) {
      if (!value) {
        clearInterval(this.autoState);
      } else {
        this.autoState = setInterval(this.moveNext, 5000);
      }
    },
    setFontFamily(font) {
      this.selectedFont = font.name;
      this.selectedFontText = font.title;
    },
    setTheme(type) {
      this.theme = type.name;
    },
    setFontSize(payload) {
      this.editorValue.fontSize = payload;
    },
  },
};
</script>

<style lang="scss" scoped>
#Font2021 {
  #font-info {
    overflow: hidden;
    background: url('https://static.gabia.com/fonts/project/image/bg_image_2021_1.svg'), url('https://static.gabia.com/fonts/project/image/bg_image_2021_2.svg') ;
    background-repeat: no-repeat;
    background-position: 25% -22%, 81% 118%;
  }
  .section-contents-wrapper {
    width: 980px;
    margin: 0 auto;
    .sub-description {
      padding: 0 20px;
      margin-top: 50px;
    }
  }
  .section-contents-project-info {
    position: relative;
    margin-top: 70px;
    .project-info-type {
      position: absolute;
      display: flex;
      top: -160px;
      right: 0;
      justify-content: flex-end;
      column-gap: 14px;
      .type-font-btn {
        cursor: pointer;
        width: 270px;
        text-align: center;
        border: 1px solid #0a0a0a;
        padding: 20px;
        font-size: 22px;
        &.active_blue {
          font-weight: 600;
          background-color: #44B4E6;
        }
        &.active_green {
          font-weight: 600;
          background-color: #72CE16;
        }
      }
    }
    .project-info-title {
      margin-bottom: 30px;
    }
    .project-info-description {
      margin-bottom: 50px;
    }
    .project-info-slide-wrapper {
      position: relative;
      .slide-nav-control {
        display: flex;
        position: absolute;
        right: 0;
        bottom: 0;
        align-items: center;
        z-index: 100;
        .prev, .next {
          cursor: pointer;
          width: 50px;
          height: 50px;
        }
        .nav-text {
          .current {
            font-weight: 600;
          }
        }
        &.blue {
          svg .arrow {
            fill: #44B4E6;
            stroke: #0a0a0a;
          }
        }
        &.green {
          svg .arrow {
            fill: #72CE16;
            stroke: #0a0a0a;
          }
        }
      }
      .slide-wrapper{
        display: flex;
        overflow: hidden;
        position: relative;
        min-height: 478px;
        .project-info-item {
          width: 100%;
          flex-shrink: 0;
          position: absolute;
          height: 100%;
          background-color: #fff;
          transition: transform 1000ms ease;
          display: none;
          .project-image {
            height: 336px
          }
          .project-text {
            padding: 30px;
            height: 142px;
            border-top: 1px solid #0a0a0a;
          }
          &.current {
            display: block;
            z-index: 2;
            transform: translate3d(0, 0, 0);
          }
          &.prev {
            display: block;
            z-index: 1;
            transform: translate3d(-100%, 0, 0);
          }
          &.next {
            display: block;
            z-index: 1;
            transform: translate3d(100%, 0, 0);
          }
        }
      }

    }
  }
  .section-contents-editor {
    position: relative;
    width: 100%;
    height: 500px;
    background-color: #fff;
    margin-top: 100px;
    .text-editor-control {
      position: absolute;
      width: 100%;
      top: 100%;
      margin-top: 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &> div {
        width: 200px;
      }
    }
    .sample-text-editor {
      position: absolute;
      width: 100%;
      max-height: 100%;
      padding: 50px;
      z-index: 100;
      font-size: 100px;
      outline: none;
      text-align: center;
      overflow-y: auto;
      color: #555555;
      &.maeumgyeol {
        font-family: 'Maeumgyeol';
      }
      &.cheongyeon {
        font-family: 'cheongyeon';
        text-align: left;
        writing-mode: vertical-rl;
      }
    }
    &.dark {
      background-color: #1f1f1f;
      .sample-text-editor {
        color: #bababa;
      }
      [contenteditable=true]:empty:before {
        content: attr(placeholder);
        display: block;
        color: #6f6f6f;
      }
    }
    [contenteditable=true]:empty:before {
      content: attr(placeholder);
      display: block;
      color: #ddd;
    }
    .content-editor-wrapper {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 99;
      display: flex;
      align-items: center;
      justify-content: center;
      &:before {
        content: url('https://static.gabia.com/fonts/project/image/db_quotation.svg');
        position: absolute;
        top:0;
        left:0;
        transform: translate(-50%, -50%);
      }
      &:after {
        content: url('https://static.gabia.com/fonts/project/image/db_quotation.svg');
        position: absolute;
        bottom:0;
        right:0;
        transform: translate(50%, 50%) rotate(180deg);
      }
    }
  }
}
</style>
